<template>
  <div>
    <div class="start-page">
      <div v-if="loader" class="loader">
        <b-spinner variant="primary" type="grow" :label="`${this.$t('reports.loadingLabel')}...`"></b-spinner>
      </div>
      <div class="row" v-else>
        <div class="col-12" v-if="hasMetric('REVIEWS')">
          <reviews :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('CSAT')">
          <csat :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('LIKERT')">
          <likert :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('EMOTION')">
          <emotion :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('LIKE/DISLIKE')">
          <likeDislike :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('MULTIPLE')">
          <multiples :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('MULTIPLE-CUSTOM')">
          <multiple-custom :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('CES')">
          <ces :showCollapsed="false" />
        </div>
        <div class="col-12" v-if="hasMetric('NPS')">
          <nps :showCollapsed="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import reviews from './components/reviews';
import csat from './components/csat';
import nps from './components/nps';
import ces from './components/ces';
import likeDislike from './components/like-dislike';
import likert from './components/likert';
import emotion from './components/emotion';
import multiples from './components/multiples';
import multipleCustom from './components/multiple-custom';
import EventBus from '../../../../../eventBus';
import api from '../../../../../services/api';

export default {
  name: 'Rankings',
  components: {
    reviews,
    csat,
    nps,
    likeDislike,
    likert,
    emotion,
    multiples,
    ces,
    multipleCustom
  },

  data: () => ({
    loader: true,
    lang: 'br',
    companyTypes: []
  }),
  methods: {
    async loadReports() {
      const response = await api.post(`/get-additionalQuestions-metrics`, {
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        groupId: this.actionGroupData ? this.actionGroupData._id : null,
      }, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      if (response.data) {
        this.companyTypes = response.data;
      }

      this.loader = false;
    },
    hasMetric(type) {
      if (this.companyTypes.includes(type)) {
        return true
      }
      return false
    }
  },
  watch: {
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
    },
    actionGroupData: function watchActionGroupData() {
      this.loadReports()
    },
    myActionId: function watchMyActionId() {
      this.loadReports()
    },
    myActionsIds: function watchMyActionsIds() {
      this.loadReports()
    },
  },
  async mounted() {
    // EventBus.$on('loadReview', () => {
    //   this.loader = false;
    // });

    this.lang = this.$i18n.locale;
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.loadReports()
  },
  computed: {
    ...mapState('actions', ['myActionId', 'myActionsIds', 'actionGroupData']),
  }
};
</script>

<style>
.scoreTh,
.totalTh {
  width: 70px;
  padding-right: 0px !important;
}

.progressTh {
  font-size: 0;
  width: 11%;
  padding-right: 0px !important;
  padding-left: 2px !important;
}

.progressTh:focus {
  outline: none;
}

.questionTh {
  width: calc(100% - 200px);
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.start-page{margin-top: 4rem;}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/index.vue